import React from 'react';
import s from './button.module.scss';

export default ({ href, children, element, className, state, invert, bold, ...props }) => {
  if (href && href.includes('http')) {
    return (
      <a
        rel="nofollow noopener noreferrer"
        target="_blank"
        href={props.to}
        className={` ${s.default} ${className || ''} ${invert ? s.invert : ''} ${bold ? s.bold : ''}`}
      >
        {children}
      </a>
    );
  }
  if (href) {
    return (
      <a
        state={state}
        href={href}
        {...props}
        as={element || 'button'}
        className={` ${s.default} ${className || ''} ${invert ? s.invert : ''} ${bold ? s.bold : ''}`}
      >
        {children}
      </a>
    );
  }
  return (
    <button {...props} className={` ${s.default} ${className || ''} ${invert ? s.invert : ''} ${bold ? s.bold : ''}`}>
      {children}
    </button>
  );
};
